import { useContext } from 'react'

import { ClientContext } from './ClientProvider.js'

export const useTribeClient = () => {
  return useContext(ClientContext)
}
